class TiProductTabs {
  constructor(root) {
    this.root = root;
    if (root.classList.contains('is-enhanced')) return;
    this.tabs = Array.from(root.querySelectorAll('[data-ti-product-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-ti-product-panel]'));
    if (this.tabs.length < 2 || this.panels.length !== this.tabs.length) return;

    root.classList.add('is-enhanced');
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
    this.activate(0, false);
  }

  activate(index, focus = true) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      this.panels[tabIndex].hidden = !active;
    });
    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    const isRtl = document.documentElement.dir === 'rtl';
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (event.key === 'ArrowRight') {
      nextIndex = isRtl
        ? (index - 1 + this.tabs.length) % this.tabs.length
        : (index + 1) % this.tabs.length;
    }
    if (event.key === 'ArrowLeft') {
      nextIndex = isRtl
        ? (index + 1) % this.tabs.length
        : (index - 1 + this.tabs.length) % this.tabs.length;
    }
    this.activate(nextIndex);
  }
}

const initializeTiProductTabs = (scope = document) => {
  scope.querySelectorAll('[data-ti-product-tabs]').forEach((root) => new TiProductTabs(root));
};

initializeTiProductTabs();
document.addEventListener('shopify:section:load', (event) => initializeTiProductTabs(event.target));
